import { render } from "./SucursalSelector.vue?vue&type=template&id=524d4514&scoped=true"
import script from "./SucursalSelector.vue?vue&type=script&lang=js"
export * from "./SucursalSelector.vue?vue&type=script&lang=js"

import "./SucursalSelector.vue?vue&type=style&index=0&id=524d4514&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524d4514"]])

export default __exports__